import { useCallback } from "react"

export const useShare = id => {
  const link = `https://motorata.pl/oferta/${id}`
  const handleCopyLink = useCallback(() => {
    navigator.clipboard.writeText(link)
  }, [])

  const handleShareWithFB = useCallback(() => {
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${link}`, "_blank")
  }, [])

  const handleShareWithLinkedIn = useCallback(() => {
    window.open(`https://www.linkedin.com/shareArticle/?url=${link}`, "_blank")
  }, [])

  return {
    handleCopyLink,
    handleShareWithFB,
    handleShareWithLinkedIn,
  }
}
